<template>
  <div>
    <GraficosCustom v-if="typeTela === 'analytic'" @click="teste" :data-chart="xAxisData" :label-series="series"/>
    <video-player
        class="video-player-box"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        customEventName="customstatechangedeventname"
        :global-options="{
          controls: typeTela === 'analytic' ? false : true
        }"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @waiting="onPlayerWaiting($event)"
        @playing="onPlayerPlaying($event)"
        @loadeddata="onPlayerLoadeddata($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @canplay="onPlayerCanplay($event)"
        @canplaythrough="onPlayerCanplaythrough($event)"
        @statechanged="playerStateChanged($event)"
        @ratechange="onPlayerRateChange($event)"
        @ready="playerReadied"
    >
    </video-player>
  </div>

</template>

<script>
// Similarly, you can also introduce the plugin resource pack you want to use within the component
// import 'some-videojs-plugin'
// import 'video.js/dist/video-js.css'

import {useApi} from '@/composables/useApi'
import {AnalyticService} from "@/services/Analytic";
import GraficosCustom from "@/components/analytics/GraficosCustom.vue";
const api = useApi()
export default {
  props: ['dataSrc', 'dataVideo', 'timeAtual', 'typeTela'],
  components: {GraficosCustom},
  data() {
    return {
      xAxisData: ['0:00', '0:35', '1:10', '1:45', '2:10','2:10','2:10'],
      series: ['10','9','7', '6', '3', '2', '16'],
      canplaythrough: [],
      waiting: [],
      currentTime: null,
      playerOptions: {
        // videojs options
        muted: false,
        language: 'pt_BR',
        playbackRates: [0.7, 1.0, 1.5, 2.0, 3.0],
        sources: [{
          type: "video/mp4",
          src: '',
        }],
        poster: "/img/LogoVls.baf294fc.png",
      },
    }
  },
  async created() {

    this.playerOptions.sources[0].src = this.srcVideo
  },
  watch: {
    timeAtual(val) {
      console.log(val)
    },
  },
  mounted() {

    // console.log('this is current player instance object', this.player)
  },
  computed: {
    srcVideo: {
      get() {
        return this.dataSrc
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    teste(e) {
      this.player.play()
      this.player.currentTime(parseInt(e.value))
      this.player.pause()

    },
    // listen event
    onPlayerPlay(player) {
      console.log('player play!', player.cache_.duration)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied(player) {
      // adicionar visualização no video
      // console.log('adicionar visualização no video')
      // console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    onPlayerCanplaythrough(player) {
      // this.canplaythrough.push(player.player_.cache_.currentTime)
      // console.log(this.canplaythrough)
      // console.log('onPlayerCanplaythrough', player.player_.cache_.currentTime)
    },
    onPlayerEnded(player) {
      // console.log('onPlayerEnded', player)
    },
    onPlayerWaiting(player) {
      // this.waiting.push(player.player_.cache_.currentTime)
      // console.log(this.waiting)
      // console.log('onPlayerWaiting', player.player_.cache_.currentTime)
    },
    onPlayerLoadeddata(player) {
      // console.log('onPlayerLoadeddata', player)
    },
    onPlayerPlaying(player) {
      // console.log('onPlayerPlaying', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('onPlayerTimeupdate', player.player_.cache_.currentTime)
    },
    onPlayerCanplay(player) {
      // console.log('onPlayerCanplay', player)
    },
    onPlayerRateChange(player) {
      // console.log('onPlayerRateChange', player)
    },
  }
}
</script>

<style>

</style>